module.exports = __webpack_public_path__ + "img/moon-7.ad4b2bd4.svg";